"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const chrome_storage_async_map_1 = require("./chrome-storage-async-map");
class ChromeStorageAssignmentCache {
    constructor(chromeStorage) {
        this.storage = new chrome_storage_async_map_1.default(chromeStorage);
    }
    set(entry) {
        // "fire-and-forget" - we intentionally don't wait for the promise to resolve
        // noinspection JSIgnoredPromiseFromCall
        this.storage.set((0, js_client_sdk_common_1.assignmentCacheKeyToString)(entry), (0, js_client_sdk_common_1.assignmentCacheValueToString)(entry));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    has(_entry) {
        throw new Error('This should never be called for ChromeStorageAssignmentCache, use getEntries() instead.');
    }
    async getEntries() {
        const entries = await this.storage.entries();
        return Object.entries(entries).map(([key, value]) => [key, value]);
    }
}
exports.default = ChromeStorageAssignmentCache;
//# sourceMappingURL=chrome-storage-assignment-cache.js.map